import React from 'react'
import { ReactElement, useEffect } from 'react'
import { ExternalRouteNames } from 'constants/routeNames'

const NotFound = (): ReactElement => {
  useEffect(() => {
    window.location.assign(ExternalRouteNames.ATD_404)
  }, [])
  return <></>
}

export default NotFound
